import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react'
import { globalCss } from './global-css'
import { breakpoints } from './breakpoints'
import { semanticTokens } from './semantic-tokens'
import { tokens } from './tokens'

export const themeConfig = defineConfig({
  preflight: true,
  cssVarsPrefix: 'chakra',
  cssVarsRoot: ':where(:root, :host)',
  globalCss,
  theme: {
    breakpoints,
    semanticTokens,
    tokens,
  },
})

export const system = createSystem(defaultConfig, themeConfig)
